export const spaceBetweenColumns = 16;
